module.exports = __webpack_public_path__ + "img/PDFIcon.ddd2b3fd.png";